import React, { useState, useEffect, useReducer } from "react";
import ResetPasswordForm from "../../components/common/ResetPasswordForm";

import { useHistory } from "react-router-dom";

// Scss imports
import css from "./ResetPassword.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { forgotPassword } from "../../redux/actions/loginAction";

interface ResetPasswordProps {}

const ResetPassword: React.FC<ResetPasswordProps> = ({}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const forgotPasswordMessage = useSelector(
    (state: any) => state.login.forgotPasswordMessage
  );

  // Setting state for disabled button
  const [disabledButton, setDisabledButton] = useState(true);

  // Setting up state for input values, using use reducer hook
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      email: ""
    }
  );

  // Setting up form
  const [form, setForm] = useState({
    email: userInput.email
  });

  // Setting up error text state
  const [errorText, setErrorText] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      email: ""
    }
  );

  useEffect(() => {
    // Set button status to enabled when all fields are valid
    if (
      userInput.email.match(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
      ) != null
    ) {
      setDisabledButton(false);
    }

    setForm({ email: userInput.email });
  }, [userInput.email, errorText]);

  // Login button handler
  const onClickButtonHandler = (e: any) => {
    //history.push("/basic-account");
    dispatch(forgotPassword(form, history));
  };

  // On input change set input name and value to text that user added
  const handleChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };

  // Set error on input
  const onInputHandler = (e, errorType, error, pattern) => {
    const newValue = e.target.value;
    // Validation with pattern
    if (newValue.match(pattern) == null) {
      setErrorText({
        [errorType]: error
      });
      setDisabledButton(true);
    }
    if (newValue.match(pattern) != null) {
      setErrorText({
        [errorType]: ""
      });
    }
  };
  return (
    <div className={css.container}>
      <div className={css.resetPasswordFormWrapper}>
        <ResetPasswordForm
          onClickButtonHandler={onClickButtonHandler}
          handleChange={handleChange}
          email={userInput.email}
          errorEmailText={errorText.email}
          forgotPasswordMessage={forgotPasswordMessage}
          disabledButton={disabledButton}
          onInputEmail={(e) =>
            onInputHandler(
              e,
              "email",
              "Унеси исправну имејл адресу",
              "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
            )
          }
        />
      </div>
    </div>
  );
};

export default ResetPassword;
